<template>
</template>

<script>
import {EventBus} from "@/events/event-bus";
import {deleteCustomerSignatureAction} from '@/modules/common/api'
export default {
    name: "initVuex",
  created() {
  },
}
</script>
<style scoped></style>

